import { Injectable } from '@angular/core';
import { Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { AwsHttp } from '../aws/http';
import { ErrorHandler } from '../restapi/error-handler';
import { UserService } from '../user/user.service';
import { SystemInformation } from './systeminformation';

@Injectable()
export class SystemInformationService {
    constructor(
        private http: AwsHttp,
        private errorHandler: ErrorHandler,
        private userService: UserService
    ) { }

    getSystemInformation(): Observable<SystemInformation> {
        let headers = new Headers({
            'Content-Type': 'application/json'
        });
        let baseUrl = this.userService.getApiUrl();
        let url = `${baseUrl}/systeminformation`;
        return this.http
            .get(url, { headers: headers })
            .map((response: Response) => response.json())
            .catch((response: Response) => this.errorHandler.throwError(response));
    }
}



// WEBPACK FOOTER //
// ./src/app/systeminformation/systeminformation.service.ts